/// <reference path="../../app.ts" />
/// <reference path="../subcataccordion.ts" />
/// <reference path="../isubcataccordion.ts" />
module Cfnc
{
    "use strict";
    export class NumericRadio
    {
        label: string;
        num: number;
    }

    export class DistanceOptions extends SubCatAccordion implements IsubCatAccordion
    {
        distances: NumericRadio[];
        distances2: NumericRadio[];
        zipCode: string;
        selectedDistance: NumericRadio;
        selectedDistance2: NumericRadio;
        selectedWithin: boolean;
        selectedRanges: Array<string>;
        distance: number;

        constructor()
        {
            super();
            this.distances = [{ label: "< 25 miles", num: 24 },
                { label: "< 50 miles", num: 49 },
                { label: "< 100 miles", num: 99 },
                { label: ">= 100 miles", num: 100 }];

            this.distances2 = [{ label: "Less than 25 miles", num: 24 },
                { label: "Less than 50 miles", num: 49 },
                { label: "Less than 100 miles", num: 99 },
                { label: "Greater than 100 miles", num: 100 }];

            this.selectedDistance = this.distances[2];
            this.selectedDistance2 = this.distances2[2];

            this.selectedRanges = new Array<string>();
        }

        public updatedSelected(range: number)
        {
            switch ( range )
            {
                case 24:
                    this.selectedDistance = this.distances[0];
                    this.selectedDistance2 = this.distances2[0];
                    break;
                case 49:
                    this.selectedDistance = this.distances[1];
                    this.selectedDistance2 = this.distances2[1];
                    break;
                case 99:
                    this.selectedDistance = this.distances[2];
                    this.selectedDistance2 = this.distances2[2];
                    break;
                case 100:
                    this.selectedDistance = this.distances[3];
                    this.selectedDistance2 = this.distances2[3];
                    break;
                default:
                    this.selectedDistance = this.distances[2];
                    this.selectedDistance2 = this.distances2[2];
                    break;
            }
        }

        public getSelectedTypes(): string[]
        {
            
            this.selected = false;
            this.selectedRanges.length = 0;
            if ( typeof this.zipCode !== "undefined" && this.zipCode.length == 5 )
            {
                this.selectedRanges.push( this.selectedDistance.label + " from " + this.zipCode );
                this.selected = true;
                return this.selectedRanges;
            }
            else
                return null;
        }
    }
}